import React from 'react';
// Components and Containers
import BarbecueForm from '../containers/BarbecueForm';
import BarbecueCart from '../containers/BarbecueCart';
import { ColorRow } from '../../common';
// Styles
import './BarbecueCalculator.css';

const BarbecueCalculator = () => {
  return (
    <div className="barbecue-calculator-container">
      <ColorRow color="orange" text="CHURRASCÔMETRO" />
      <div className="barbecue-calculator-header">
        <h1 className="header-title">Big Churrasco</h1>
        <h4 className="header-subtitle">O seu melhor churrasco começa aqui!</h4>
      </div>
      <div className="barbecue-calculator-content">
        <BarbecueForm />
        <BarbecueCart />
      </div>
    </div>
  );
};

export default BarbecueCalculator;
